import { useMemo } from 'react';
import { useFormContext } from 'react-hook-form';

import { FOR_BANK_SECTIONS, FOR_BANK_SUB_SECTIONS } from 'constants/businessToolSections/forBank';
import { debounce } from 'lodash';

import useCheckSubSectionAccess from 'hooks/useCheckSubSectionAccess';

import { IPeriodsTableRows } from 'components/BusinessToolForm/constants/periods';
import { PERIODS_OPERATION_TYPES, summarizeSubtractPeriodValues } from 'components/BusinessToolForm/utils/helpers';

import { observedFields } from '../../utils/form';

export const useGetTotalNonCurrentAssetsCalculation = () => {
  const { setValue } = useFormContext();

  const canAccess = useCheckSubSectionAccess(
    FOR_BANK_SECTIONS.MARKETING_AND_SALES,
    FOR_BANK_SUB_SECTIONS.FOR_BANK_MARKETING_AND_SALES.SALES_PLAN,
  );

  const [nonCurrentAssetsFiled] = observedFields.nonCurrentAssetsTotal.setCalculatedValueFieldNames;

  const getTotalNonCurrentAssetsCalculationHandler = useMemo(
    () =>
      debounce((content) => {
        if (!canAccess) return;

        const nonCurrentAssetsTableValues = Object.values(content[0]) as IPeriodsTableRows[];
        const nonCurrentAssetsTotal = summarizeSubtractPeriodValues(
          nonCurrentAssetsTableValues,
          PERIODS_OPERATION_TYPES.ADD,
        );

        setValue(nonCurrentAssetsFiled, nonCurrentAssetsTotal);
      }, 500),
     
    [],
  );

  return getTotalNonCurrentAssetsCalculationHandler;
};
